// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"TalentGardenApps_wrapper__ijIjA","imageWrapper":"TalentGardenApps_imageWrapper__6I9Dr","image":"TalentGardenApps_image__ENbU6"};